import React from 'react';
import { Skeleton } from '../Skeleton';
const QuestionLoader = () => {
  return (
    <>
      <div className="col-lg-8 col-12 spqQuestionBox text-start rounded">
        <h1 className="fs-2 text-black fw-semibold spqQuestionTopic mb-4">
          <Skeleton variant="rectangular" width={'100%'} height={22} />
        </h1>
        <div className="w-100">
          <h2 className="fs-3 fw-medium spqQuestionTtl text-black mt-4 mb-3">
            <Skeleton variant="rectangular" width={'100%'} height={40} className="rounded" />
          </h2>
          <div className="w-100  mt-4">
            <div className="spqAnswerArea">
              <Skeleton variant="rectangular" width={'50%'} height={20} className="my-2 rounded" />
              <Skeleton variant="rectangular" width={'50%'} height={20} className="my-2 rounded" />
              <Skeleton variant="rectangular" width={'50%'} height={20} className="my-2 rounded" />
              <Skeleton variant="rectangular" width={'50%'} height={20} className="my-2 rounded" />

              <div className="w-100">
                <div className="row justify-content-center mt-4">
                  <div className="col-lg-6 col-md-8 col-12 text-center spqAnswerSubmit mt-4">
                    <Skeleton variant="rectangular" width={'100%'} height={20} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionLoader;
